/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessReportFilterFromJSON, BusinessReportFilterToJSON, } from './BusinessReportFilter';
/**
 * Check if a given object implements the BusinessReportDeleteRequest interface.
 */
export function instanceOfBusinessReportDeleteRequest(value) {
    if (!('filter' in value) || value['filter'] === undefined)
        return false;
    return true;
}
export function BusinessReportDeleteRequestFromJSON(json) {
    return BusinessReportDeleteRequestFromJSONTyped(json, false);
}
export function BusinessReportDeleteRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'filter': BusinessReportFilterFromJSON(json['filter']),
        'selectAll': json['selectAll'] == null ? undefined : json['selectAll'],
        'inventoryIds': json['inventoryIds'] == null ? undefined : json['inventoryIds'],
        'excludeRecentlySold': json['excludeRecentlySold'] == null ? undefined : json['excludeRecentlySold'],
    };
}
export function BusinessReportDeleteRequestToJSON(json) {
    return BusinessReportDeleteRequestToJSONTyped(json, false);
}
export function BusinessReportDeleteRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'filter': BusinessReportFilterToJSON(value['filter']),
        'selectAll': value['selectAll'],
        'inventoryIds': value['inventoryIds'],
        'excludeRecentlySold': value['excludeRecentlySold'],
    };
}
